
<template>

<el-dialog title="保存埋点" :visible.sync="visible" :close-on-click-modal="false" :destroy-on-close="true" width="30%">
    <el-form :model="employeeFrom" ref="employeeDialogFrom" label-width="120px">

        <el-form-item label="页面" prop="nativeLocation" :rules="[{ required: true, message: '页面路径不能为空'}]">
            <el-input v-model="employeeFrom.nativeLocation"  placeholder="请输入页面路径"></el-input>
        </el-form-item>

        <el-form-item label="页面正则" prop="location" :rules="[{ required: true, message: '页面路径不能为空'}]">
            <el-input v-model="employeeFrom.location"  placeholder="请输入页面路径"></el-input>
        </el-form-item>

        <el-form-item label="页面名" prop="locationDescribe" :rules="[{ required: true, message: '页面名'}]">
            <el-input v-model="employeeFrom.locationDescribe" placeholder="请输入页面名"></el-input>
        </el-form-item>

        <el-form-item label="埋点" v-if="isShowClick"  prop="nativeXPath" :rules="[{ required: true, message: '埋点路径不能为空'}]">
            <el-input v-model="employeeFrom.nativeXPath"  placeholder="请输入埋点路径"></el-input>
        </el-form-item>

        <el-form-item label="埋点正则" v-if="isShowClick"  prop="xPath" :rules="[{ required: true, message: '埋点路径不能为空'}]">
            <el-input v-model="employeeFrom.xPath"  placeholder="请输入埋点路径"></el-input>
        </el-form-item>

        <el-form-item label="埋点名称" v-if="isShowClick" prop="xPathDescribe" :rules="[{ required: true, message: '埋点名不能为空'}]">
            <el-input v-model="employeeFrom.xPathDescribe" placeholder="请输入埋点名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="isShowClick">显示事件埋点</el-checkbox>
        </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
        <el-button @click="hide()">取 消</el-button>
        <el-button type="primary" @click="validateFrom('employeeDialogFrom',save)" :loading="loading">保 存</el-button>
    </div>

</el-dialog>

</template>

<script>
import BasicModel from '@/framework/basic/BasicModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'save-x-path-dialog',
  extends: BasicPager,
  data: function () {
    return {
      employeeFrom: {
        xPath: null,
        xPathDescribe: null,
        location: null,
        locationDescribe: null,
        nativeLocation: null,
        nativeXPath: null,
        _xPathId: null,
        _locationId: null,
        module: null
      },
      showPage: true,
      isShowClick: false,
      loading: false,
      visible: false
    }
  },
  watch: {
    visible: function (newVisible) {
      this.$emit('onVisibleChanged', newVisible)
    }
  },
  methods: {
    save: function () {
      let _this = this

      _this.loading = true

      let employeeFrom = JSON.parse(JSON.stringify(this.employeeFrom))

      if (!this.isShowClick) {
        delete employeeFrom._xPathId
        delete employeeFrom.nativeXPath
        delete employeeFrom.xPathDescribe
        delete employeeFrom.xPath
      }

      let listener = {
        success: function (dataInfo) {
          _this.loading = false
          _this.visible = false
          _this.$message.success('埋点保存成功！')
        },
        error: function (response) {
          _this.loading = false
          _this.$message({
            type: 'error',
            message: response.data.errMsg
          })
        }
      }

      BasicModel.post(this, '/main/saveBuriedPointInfo.action', employeeFrom, listener)
    },
    show: function (data) {
      this.employeeFrom.location = data.location
      this.employeeFrom.locationDescribe = data.locationDescribe
      this.employeeFrom.xPath = data.xPath
      this.employeeFrom.xPathDescribe = data.xPathDescribe
      this.employeeFrom.nativeLocation = data.nativeLocation
      this.employeeFrom.nativeXPath = data.nativeXPath
      this.employeeFrom._xPathId = data._xPathId
      this.employeeFrom._locationId = data._locationId
      this.employeeFrom.module = data.module
      this.visible = true

      if (data._xPathId) {
        this.isShowClick = true
      } else {
        this.isShowClick = false
      }

      if (data.locationDescribe) {
        this.showPage = true
      } else {
        this.showPage = false
      }
    },
    hide: function () {
      this.visible = false
    }
  }
}

</script>
